import React from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import HelmetWrapper from "../../HelmetWrapper";
import { selectAuth } from "../../components/auth/auth.selector";
import FollowupAnalytics from "../../components/lead-management/FollowupAnalytics";

const FollowupAnalyticsPage = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return (
    <HelmetWrapper title="WTF: Follow-up Analytics">
      <Container className="bg-cloud-k px-50px" fluid>
        <FollowupAnalytics userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default FollowupAnalyticsPage;
